import { render, staticRenderFns } from "./edit-actions.vue?vue&type=template&id=4128e0fa&scoped=true"
import script from "./edit-actions.vue?vue&type=script&lang=js"
export * from "./edit-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128e0fa",
  null
  
)

export default component.exports